<app-tabla
  [totalCount]="totalCount"
  [datos]="usuarios"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay técnicos' }"
></app-tabla>

<app-image-viewer
  [imageUrl]="fotoUrl"
  [isVisible]="fotoVisible"
  [altText]="fotoAlt"
  (closeViewer)="fotoVisible = false"
></app-image-viewer>
